(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/system-selector/system-reduce-free.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/system-selector/system-reduce-free.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Inputv2 = _svs$ui$reactForm.Inputv2;
const setReduceModeCount = svs.components.tipsen.engine.actions.setReduceModeCount;
const selectReduceCount = svs.components.tipsen.engine.selectors.couponSelectors.selectReduceCount;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const SystemSelectorWrapper = svs.components.tipsen.routePlaySpela.systemSelector.SystemSelectorWrapper;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;


function restArguments(func, startIndex) {
  startIndex = startIndex === undefined || startIndex === null ? func.length - 1 : +Number(startIndex);
  return function () {
    const length = Math.max(arguments.length - startIndex, 0);
    const rest = Array(length);
    let index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0:
        return func.call(this, rest);
      case 1:
        return func.call(this, arguments[0], rest);
      case 2:
        return func.call(this, arguments[0], arguments[1], rest);
    }
    const args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}
function debounce(func, wait, immediate) {
  let timeout;
  let previous;
  let args;
  let result;
  let context;
  const later = function () {
    const passed = Date.now() - previous;
    if (wait > passed) {
      timeout = setTimeout(later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
      }
      if (!timeout) {
        args = context = null;
      }
    }
  };
  const debounced = restArguments(function (_args) {
    context = this;
    args = _args;
    previous = Date.now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
      if (immediate) {
        result = func.apply(context, args);
      }
    }
    return result;
  });
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = args = context = null;
  };
  return debounced;
}
const SystemReduceFree = _ref => {
  let isExtraSmall = _ref.isExtraSmall;
  const couponId = useCouponId();
  const dispatch = useDispatch();
  const reduceCount = useSelector(state => selectReduceCount(state, couponId));
  const _useState = useState(reduceCount),
    _useState2 = _slicedToArray(_useState, 2),
    rowNumbers = _useState2[0],
    setRowNumbers = _useState2[1];
  const _useState3 = useState({
      error: false,
      message: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    rowErrors = _useState4[0],
    setRowErrors = _useState4[1];
  const setError = useCallback(message => {
    setRowErrors({
      error: true,
      message
    });
  }, []);
  const removeError = () => {
    setRowErrors({
      error: false,
      message: ''
    });
  };
  const debouncer = useRef();
  useEffect(() => {
    debouncer.current = debounce(value => {
      if (value < 20) {
        setError('Det måste vara minst 20 rader');
      } else if (value > 2200) {
        setError('Det får inte vara mer än 2200 rader');
      }
    }, 500);
    return () => {
      debouncer.current.cancel();
    };
  }, [setError]);
  useEffect(() => {
    const value = Number(rowNumbers);
    const rangeIsOk = value >= 20 && value <= 2200;
    if (!Number.isNaN(value) && rowNumbers && rowNumbers.length > 0) {
      debouncer.current(value);
    }
    if (!rowNumbers || rowNumbers.length === 0 || rangeIsOk) {
      removeError();
      debouncer.current.cancel();
    }
    if (rangeIsOk || !value) {
      dispatch(setReduceModeCount({
        couponId,
        value
      }));
    }
  }, [couponId, dispatch, rowNumbers]);
  const rowInputChange = e => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setRowNumbers(value ? value : '');
  };
  return React.createElement(SystemSelectorWrapper, {
    elementClassName: isExtraSmall ? 'tipsen-reduce-paper' : null,
    isExtraSmall: isExtraSmall,
    systemType: SYSTEM_REDUCERA_FRITT
  }, React.createElement("div", {
    className: "tipsen-system-selector-reduce-input"
  }, React.createElement("div", {
    className: "tipsen-system-selector-reduce-input__explanation"
  }, "Med reducera fritt styr du radf\xF6rdelning och pris i ditt system. \xA0", React.createElement(TipsenLink, {
    to: "/".concat(TipsenModuleGameUrl.SYSTEM, "/spelguide")
  }, "L\xE4s mer om Reducera Fritt.")), React.createElement(Form, {
    isVertical: true,
    onSubmit: e => e.preventDefault()
  }, React.createElement(ControlGroup, {
    errorMessage: rowErrors.message,
    hasError: rowErrors.error,
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    id: "reactreduceRows",
    inputHelpText: "Ange antal rader mellan 20 - 2200",
    label: "Ange antal rader mellan 20 - 2200",
    min: "0",
    onChange: rowInputChange,
    suffix: rowNumbers ? 'rader' : '',
    type: "tel",
    value: rowNumbers !== null && rowNumbers !== void 0 ? rowNumbers : ''
  })))));
};
setGlobal('svs.components.tipsen.routePlaySpela.systemSelector.SystemReduceFree', SystemReduceFree);

 })(window);